<template>
  <div class="hidden">
    <component ref="components" v-for="(item, index) in items" :key="index" :is="item.component" v-bind="item.inputProps" />
  </div>
</template>

<script setup>
import { ref } from "vue"

import * as quasarUtils from "@/services/quasarUtils.js"

const props = defineProps({
  items: Array
})

const components = ref([])

const emit = defineEmits(["invalidate", "validate", "result"])

const validate = async () => {
  const invalidItems = []
  await Promise.allSettled(
    components.value.map(async (item, index) => {
      try {
        if (!(await item.validate())) {
          emit("invalidate", props.items[index].validatedItem)
          invalidItems.push(props.items[index].validatedItem)
        } else {
          emit("validate", props.items[index].validatedItem)
        }
      } catch (err) {
        quasarUtils.handleError(err)
      }
    })
  )

  emit("result", invalidItems)
  return invalidItems.length === 0
}

defineExpose({ validate })
</script>
